<template>
  <div v-if="editor" class="sidebar-container">
    <div v-if="editor.isActive('image')">
      <ImageSidebar :editor="editor" />
    </div>
    <div v-else-if="editor.isActive('video')">
      <VideoSidebar :editor="editor" />
    </div>
    <div v-else-if="editor.isActive('audio')">
      <AudioSidebar :editor="editor" />
    </div>
    <div v-else-if="editor.isActive('info')">
      <InfoSidebar :editor="editor" :infoValue="infoString" />
    </div>
    <div v-else><NeutralSidebar :editor="editor" /></div>
  </div>
</template>
<script>
import ImageSidebar from './ImageSidebar'
import VideoSidebar from './VideoSidebar'
import AudioSidebar from './AudioSidebar'
import InfoSidebar from './InfoSidebar'
import NeutralSidebar from './NeutralSidebar'

export default {
  components: {
    ImageSidebar,
    VideoSidebar,
    AudioSidebar,
    NeutralSidebar,
    InfoSidebar,
  },
  props: {
    editor: Object,
  },
  computed: {
    infoString() {
      if (this.editor.getAttributes('info').info) {
        return this.editor.getAttributes('info').info.toString()
      }
      return ''
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep h1 {
  font-size: 1.2em;
}
.sidebar-container {
  background-color: var(--v-background-base);
  padding: 20px 6px;
  height: 100%;
}
::v-deep  .v-expansion-panels .v-expansion-panel {
  background-color: var(--v-secondaryBackground-base);
  padding: 5px;

}
::v-deep .v-expansion-panels video,
::v-deep .v-expansion-panels img {
  background-color: transparent;
  box-sizing: border-box;
  outline-offset: -4px;

}
::v-deep h1 {
  text-align: left;
  margin-bottom: 12px;
}

::v-deep .upload-container {
  background-color: var(--v-background-base);
  width: 100%;
  border: 2px dashed #949191;
}

</style>